import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private _baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  get<T>(url: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${this._baseUrl}${url}`, { params });
  }

  getBlob(url: string, params?: HttpParams): Observable<Blob> {
    return this.http.get(`${this._baseUrl}${url}`, { params, responseType: 'blob' });
  }

  getBlobResponse(url: string, params?: HttpParams): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this._baseUrl}${url}`, { params, responseType: 'blob', observe: 'response' });
  }

  post<T>(url: string, body: any, headers?: HttpHeaders): Observable<T> {
    return this.http.post<T>(`${this._baseUrl}${url}`, body, { headers });
  }

  postBlob(url: string, body: any): Observable<Blob> {
    return this.http.post(`${this._baseUrl}${url}`, body, { responseType: 'blob' });
  }

  put<T>(url: string, body: any): Observable<T> {
    return this.http.put<T>(`${this._baseUrl}${url}`, body);
  }

  delete<T>(url: string): Observable<T> {
    return this.http.delete<T>(`${this._baseUrl}${url}`);
  }

  patch<T>(url: string, body: any = {}): Observable<T> {
    return this.http.patch<T>(`${this._baseUrl}${url}`, body);
  }
}
